import { render } from "./HomePlaning.vue?vue&type=template&id=5b894d84&scoped=true"
import script from "./HomePlaning.vue?vue&type=script&lang=js"
export * from "./HomePlaning.vue?vue&type=script&lang=js"

import "./HomePlaning.vue?vue&type=style&index=0&id=5b894d84&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b894d84"]])

export default __exports__